import React from 'react';
import styles from './ModalHeading.module.css';
import { FCWithChildren } from '../../../utility/utility.types';

const ModalHeading: FCWithChildren = ({ children }) => {
    return <div className={styles.modalHeading}>{children}</div>;
};

export default ModalHeading;
